import {
  Card,
  Button,
  Descriptions,
  Tabs,
  List,
  Tag,
  Badge,
  Typography,
  Row,
  Col,
  Avatar,
  Divider,
} from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import { useLocation } from "react-router-dom";
import {
  ArrowLeftOutlined,
  UserOutlined,
  MailOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  TeamOutlined,
  NotificationOutlined,
  FileTextOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import lang from "../helper/lang";

function ViewSurvey() {
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const location = useLocation();
  const { record } = location.state || {};
  const navigate = useNavigate();
  const { request } = useRequest();

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (record) {
      console.log("Received record:", record);
    } else {
      console.warn("No record data received.");
    }
  }, [record]);

  return (
    <>
      <div className="back-box-btn">
        <Button onClick={handleBack} className="back-button mb-2">
          <ArrowLeftOutlined /> {lang("Back")}
        </Button>
      </div>
      <Card
        title={
          <>
            <TeamOutlined /> Survey Details
          </>
        }
        bordered={false}
      >
        <Tabs defaultActiveKey="overview" type="card">
          <Tabs.TabPane
            tab={
              <>
                <FileTextOutlined /> Overview
              </>
            }
            key="overview"
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Card size="small" title="Basic Information">
                  <Descriptions size="small" column={1}>
                    <Descriptions.Item label="Survey ID">
                      {record?._id || "N/A"}
                    </Descriptions.Item>
                    {record?.baseSurvey && (
                      <Descriptions.Item label="Base Survey Name">
                        {record.baseSurvey.name || "N/A"}
                      </Descriptions.Item>
                    )}
                    <Descriptions.Item label="Survey Type">
                      <Tag color="blue">{record?.surveyType || "N/A"}</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                      <Badge
                        status={
                          record?.status === "Open" ? "success" : "default"
                        }
                        text={record?.status || "N/A"}
                      />
                    </Descriptions.Item>
                    <Descriptions.Item label="Language">
                      {record?.language || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Distribution Method">
                      {record?.distributionMethod || "N/A"}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card size="small" title="Team Information">
                  <Descriptions size="small" column={1}>
                    <Descriptions.Item label="Team Name">
                      {record?.teamName || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Team Size">
                      {record?.teamSize || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Country">
                      {record?.country || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Industry">
                      {record?.industry || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Team Role">
                      {record?.teamRole || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Company Size">
                      {record?.companySize || "N/A"}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>
            </Row>
            <Divider />
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Card size="small" title="Payment & Credits">
                  <Descriptions size="small" column={1}>
                    <Descriptions.Item label="Payment Type">
                      {record?.paymentType || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Credits Used">
                      {record?.creditsUsed || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Price USD">
                      {record?.priceUSD ? `$${record.priceUSD}` : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Discount Applied">
                      {record?.discountApplied
                        ? `$${record.discountApplied}`
                        : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="GDPR Consent">
                      {record?.gdprConsent ? (
                        <Tag color="green" style={{ cursor: 'default' }}>Yes</Tag>
                      ) : (
                        <Tag color="red" style={{ cursor: 'default' }}>No</Tag>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card size="small" title="Timestamps & Links">
                  <Descriptions size="small" column={1}>
                    <Descriptions.Item label="Created At">
                      {record?.created_at
                        ? new Date(record.created_at).toLocaleString()
                        : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Updated At">
                      {record?.updated_at
                        ? new Date(record.updated_at).toLocaleString()
                        : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Deadline">
                      {record?.deadline
                        ? new Date(record.deadline).toLocaleString()
                        : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Survey Link">
                      {record?.surveyLink ? (
                        <a
                          href={record.surveyLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LinkOutlined /> View Survey
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </Descriptions.Item>
                    {record?.surveyLeaderLink && (
                      <Descriptions.Item label="Leader Self Survey Link">
                        <a
                          href={record.surveyLeaderLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LinkOutlined /> View Leader Survey
                        </a>
                      </Descriptions.Item>
                    )}
                  </Descriptions>
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <UserOutlined /> Team Members (
                {(record?.members?.length || 0) + (record?.leader ? 1 : 0)})
              </>
            }
            key="members"
          >
            <List
              itemLayout="horizontal"
              dataSource={[
                ...(record?.leader
                  ? [
                      {
                        ...record.leader,
                        isLeader: true,
                      },
                    ]
                  : []),
                ...(record?.members || []),
              ]}
              renderItem={(member, index) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        icon={<UserOutlined />}
                        style={{
                          backgroundColor: member.isLeader
                            ? "#1890ff"
                            : undefined,
                        }}
                      />
                    }
                    title={
                      <>
                        <strong>{member.name}</strong>
                        {member.isLeader && (
                          <Tag color="blue" style={{ marginLeft: 8, cursor: 'default' }}>
                            Leader
                          </Tag>
                        )}
                        <Tag
                          color={
                            member.status === "Pending" ? "orange" : "green"
                          }
                          style={{ marginLeft: 8, cursor: 'default' }}
                        >
                          {member.status}
                        </Tag>
                      </>
                    }
                    description={
                      <>
                        <MailOutlined /> {member.email}
                        <br />
                        <ClockCircleOutlined /> Responses:{" "}
                        {member.responses?.length || 0}
                      </>
                    }
                  />
                </List.Item>
              )}
            />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <NotificationOutlined /> Notifications (
                {record?.notifications?.length || 0})
              </>
            }
            key="notifications"
          >
            <List
              itemLayout="vertical"
              dataSource={record?.notifications || []}
              renderItem={(notif) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <>
                        <Tag color="blue">{notif.type}</Tag>{" "}
                        {new Date(notif.sentAt).toLocaleString()}
                      </>
                    }
                    description={notif.details}
                  />
                </List.Item>
              )}
            />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <FileTextOutlined /> Email Template
              </>
            }
            key="email"
          >
            {record?.distributionMethod === "manual" ? (
              <Card size="small">
                <Typography.Text type="secondary">
                  This survey uses manual distribution method. No email template is available.
                </Typography.Text>
              </Card>
            ) : record?.emailTemplates ? (
              <>
                <Card
                  size="small"
                  title="Email Templates"
                  style={{ marginBottom: 16 }}
                >
                  {record.emailTemplates.leaderTemplate && (
                    <div>
                      <Typography.Text strong>
                        Leader Template:
                      </Typography.Text>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: record.emailTemplates.leaderTemplate,
                        }}
                        style={{
                          marginTop: 8,
                          padding: 8,
                          border: "1px solid #d9d9d9",
                          borderRadius: 4,
                        }}
                      />
                    </div>
                  )}

                  {record.emailTemplates.memberTemplate && (
                    <div>
                      <Typography.Text strong>
                        Member Template:
                      </Typography.Text>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: record.emailTemplates.memberTemplate,
                        }}
                        style={{
                          marginTop: 8,
                          padding: 8,
                          border: "1px solid #d9d9d9",
                          borderRadius: 4,
                        }}
                      />
                    </div>
                  )}
                </Card>
                <Divider />
              </>
            ) : record?.emailTemplate ? (
              <Card size="small" title="Email Template">
                <div
                  dangerouslySetInnerHTML={{
                    __html: record.emailTemplate,
                  }}
                  style={{
                    padding: 8,
                    border: "1px solid #d9d9d9",
                    borderRadius: 4,
                  }}
                />
              </Card>
            ) : (
              <Card size="small">
                <Typography.Text type="secondary">
                  No email template available.
                </Typography.Text>
              </Card>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane tab="Additional Details" key="details">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Card size="small" title="Survey Progress">
                  <Descriptions size="small" column={1}>
                    <Descriptions.Item label="Last Sent Count">
                      {record?.lastSentCount || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Sent Count">
                      {record?.totalSentCount || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Report Generated">
                      {record?.reportGenerated ? (
                        <Tag color="green" style={{ cursor: 'default' }}>Yes</Tag>
                      ) : (
                        <Tag color="red" style={{ cursor: 'default' }}>No</Tag>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card size="small" title="Notification Preferences">
                  {record?.notificationPreferences ? (
                    <Descriptions size="small" column={1}>
                      <Descriptions.Item label="On Submission">
                        {record.notificationPreferences.onSubmission ? (
                          <Tag color="green" style={{ cursor: 'default' }}>Enabled</Tag>
                        ) : (
                          <Tag color="red" style={{ cursor: 'default' }}>Disabled</Tag>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="Daily Digest">
                        {record.notificationPreferences.dailyDigest ? (
                          <Tag color="green" style={{ cursor: 'default' }}>Enabled</Tag>
                        ) : (
                          <Tag color="red" style={{ cursor: 'default' }}>Disabled</Tag>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="On Deadline Day">
                        {record.notificationPreferences.onDeadlineDay ? (
                          <Tag color="green" style={{ cursor: 'default' }}>Enabled</Tag>
                        ) : (
                          <Tag color="red" style={{ cursor: 'default' }}>Disabled</Tag>
                        )}
                      </Descriptions.Item>
                    </Descriptions>
                  ) : (
                    "N/A"
                  )}
                </Card>
              </Col>
            </Row>
            {record?.reportFiles && (
              <>
                <Card
                  size="small"
                  title="Report Files"
                  style={{ marginBottom: 16 }}
                >
                  <Descriptions size="small" column={1}>
                    {record.reportFiles.ppt && (
                      <Descriptions.Item label="PPT Report">
                        <a
                          href={record.reportFiles.ppt}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download PPT
                        </a>
                      </Descriptions.Item>
                    )}
                    {record.reportFiles.docx && (
                      <Descriptions.Item label="DOCX Report">
                        <a
                          href={record.reportFiles.docx}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download DOCX
                        </a>
                      </Descriptions.Item>
                    )}
                    {record.reportFiles.pdf && (
                      <Descriptions.Item label="PDF Report">
                        <a
                          href={record.reportFiles.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download PDF
                        </a>
                      </Descriptions.Item>
                    )}
                  </Descriptions>
                </Card>
                <Divider />
              </>
            )}

            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Card size="small" title="Questions">
                  {record?.questions?.length > 0 ? (
                    <List
                      size="small"
                      dataSource={record.questions}
                      renderItem={(q, index) => (
                        <List.Item>
                          <Typography.Text strong>
                            Q{index + 1}: {q.text}
                          </Typography.Text>
                          <br />
                          <Typography.Text type="secondary">
                            Type: {q.type}
                          </Typography.Text>
                          {q.options?.length > 0 && (
                            <ul style={{ marginLeft: "1rem" }}>
                              {q.options.map((opt, i) => (
                                <li key={i}>{opt}</li>
                              ))}
                            </ul>
                          )}
                        </List.Item>
                      )}
                    />
                  ) : (
                    <Typography.Text type="secondary">
                      No questions available
                    </Typography.Text>
                  )}
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card size="small" title="Open Questions">
                  {record?.openQuestions?.length > 0 ? (
                    <List
                      size="small"
                      dataSource={record.openQuestions}
                      renderItem={(q) => <List.Item>{q}</List.Item>}
                    />
                  ) : (
                    <Typography.Text type="secondary">
                      No open questions available
                    </Typography.Text>
                  )}
                </Card>
                <Card
                  size="small"
                  title="Submitted IPs"
                  style={{ marginTop: 16 }}
                >
                  {record?.submittedIPs?.length > 0 ? (
                    <List
                      size="small"
                      dataSource={record.submittedIPs}
                      renderItem={(ip) => <List.Item>{ip}</List.Item>}
                    />
                  ) : (
                    <Typography.Text type="secondary">
                      No submitted IPs
                    </Typography.Text>
                  )}
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </>
  );
}

export default ViewSurvey;
